import { useContext } from 'react'
import DialogContext from '../ConfirmDialogContext'

const useConfirmDialog = () => {
  const useDialogContext = () => useContext(DialogContext)

  const { openDialog, closeDialog, showDialog, DialogComponent } = useDialogContext()

  return { openDialog, closeDialog, showDialog, DialogComponent }
}

export default useConfirmDialog
